import axiosInstance from "../../apiAxios/axiosInstance";


export const getDepartmentList = async (payload) => {

  const response = await axiosInstance.post("/admin/department-list",payload);
  return response.data;

};



export const ActiveDepartmentList = async (payload) => {
  const response = await axiosInstance.get("/admin/active-department-list",payload);
  return response.data;
};
export const DeleteDepartment = async (payload) => {
  const res = await axiosInstance.post("/admin/department-delete", payload)
  return res.data
};
export const DepartmentUpdate = async (payload) => {
  const res = await axiosInstance.post("/admin/department-update", payload)
  return res.data
};

export const createDepartment = async (data) => {

  const response = await axiosInstance.post("/admin/department-store", data
  );

  return response.data;

};


export const getDepartmentById = async (id) => {
  const response = await axiosInstance.post("/admin/department-show", { id, });
  return response.data;
}
export const ChanegDepartmentstatus = async (paylaod) => {
  const response = await axiosInstance.post("/admin/department-status-update", paylaod)
};